import { render, staticRenderFns } from "./veStuMoralProgramShow.vue?vue&type=template&id=641f1c9f&scoped=true"
import script from "./veStuMoralProgramShow.vue?vue&type=script&lang=js"
export * from "./veStuMoralProgramShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f1c9f",
  null
  
)

export default component.exports